export const rating_fitch = [
  { value: "NR" },
  { value: "AAA" },
  { value: "AA+" },
  { value: "AA" },
  { value: "AA-" },
  { value: "A+" },
  { value: "A" },
  { value: "A-" },
  { value: "BBB+" },
  { value: "BBB" },
  { value: "BBB-" },
  { value: "BB+" },
  { value: "BB" },
  { value: "BB-" },
  { value: "B+" },
  { value: "B" },
  { value: "B-" },
  { value: "CCC" },
  { value: "CC" },
  { value: "C" },
  { value: "DDD" },
  { value: "DD" },
];
